import type {
  CreateMedicationUsage,
  MedicationDuration,
  MedicationRepeat,
} from '@quromedical/models';
import { strings } from 'strings';

export type MedicationUsageFormData = CreateMedicationUsage;

export enum EnumMedicationRepeat {
  OncePerDay = 'once-per-day',
  TwicePerDay = 'twice-per-day',
  ThreeTimesPerDay = 'three-times-per-day',
  EveryFourHours = 'every-four-hours',
  EverySixHours = 'every-six-hours',
  AsNeeded = 'as-needed',
}

export enum EnumMedicationDuration {
  OneDay = '1-day',
  ThreeDays = '3-days',
  FiveDays = '5-days',
  SevenDays = '7-days',
  FourteenDays = '14-days',
  OneMonth = '28-days',
}

export const RepeatDescription: Record<EnumMedicationRepeat, MedicationRepeat> =
  {
    [EnumMedicationRepeat.OncePerDay]: {
      frequency: 1,
      period: 1,
      periodUnit: 'd',
    },
    [EnumMedicationRepeat.TwicePerDay]: {
      frequency: 2,
      period: 1,
      periodUnit: 'd',
    },
    [EnumMedicationRepeat.ThreeTimesPerDay]: {
      frequency: 3,
      period: 1,
      periodUnit: 'd',
    },
    [EnumMedicationRepeat.EveryFourHours]: {
      frequency: 1,
      period: 4,
      periodUnit: 'h',
    },
    [EnumMedicationRepeat.EverySixHours]: {
      frequency: 1,
      period: 6,
      periodUnit: 'h',
    },
    [EnumMedicationRepeat.AsNeeded]: {
      frequency: 0,
      period: 0,
      periodUnit: undefined,
    },
  };

export const medicationFrequencyDisplay: Record<EnumMedicationRepeat, string> =
  {
    [EnumMedicationRepeat.OncePerDay]: strings.MedicationFrequencyDaily,
    [EnumMedicationRepeat.TwicePerDay]: strings.MedicationFrequencyBiDaily,
    [EnumMedicationRepeat.ThreeTimesPerDay]:
      strings.MedicationFrequencyThreeTimesADay,
    [EnumMedicationRepeat.EveryFourHours]: strings.MedicationFrequency4Hourly,
    [EnumMedicationRepeat.EverySixHours]: strings.MedicationFrequency6Hourly,
    [EnumMedicationRepeat.AsNeeded]: strings.MedicationFrequencyAsNeeded,
  };
export const DurationDescription: Record<
  EnumMedicationDuration,
  MedicationDuration
> = {
  [EnumMedicationDuration.OneDay]: { value: 1, unit: 'd' },
  [EnumMedicationDuration.ThreeDays]: { value: 3, unit: 'd' },
  [EnumMedicationDuration.FiveDays]: { value: 5, unit: 'd' },
  [EnumMedicationDuration.SevenDays]: { value: 7, unit: 'd' },
  [EnumMedicationDuration.FourteenDays]: { value: 14, unit: 'd' },
  [EnumMedicationDuration.OneMonth]: { value: 28, unit: 'd' },
};

export const medicationDurationDisplay: Record<EnumMedicationDuration, string> =
  {
    [EnumMedicationDuration.OneDay]: strings.MedicationPrescriptionLength1Day,
    [EnumMedicationDuration.ThreeDays]:
      strings.MedicationPrescriptionLength3Days,
    [EnumMedicationDuration.FiveDays]:
      strings.MedicationPrescriptionLength5Days,
    [EnumMedicationDuration.SevenDays]:
      strings.MedicationPrescriptionLength7Days,
    [EnumMedicationDuration.FourteenDays]:
      strings.MedicationPrescriptionLength14Days,
    [EnumMedicationDuration.OneMonth]:
      strings.MedicationPrescriptionLength1Month,
  };
